import React from "react";
import PropTypes from "prop-types";

const EarningIcon = ({ size = 30, color = "#2e7d32" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64">
    <circle cx="40" cy="18" r="12" fill={color} />
    <text
      x="40"
      y="23"
      textAnchor="middle"
      fontSize="18"
      fill="#fff"
      fontWeight="bold"
    >
      ₹
    </text>
    <path
      d="M8 38c0-3 2-5 5-5h18c3 0 6-1 9-3l5-4c2-2 5-2 7 0s2 5 0 7l-6 6c-4 4-9 6-14 6H18c-6 0-10-4-10-7z"
      fill={color}
    />
  </svg>
);

const DeductionIcon = ({ size = 30, color = "#d32f2f" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64">
    <circle cx="32" cy="32" r="20" fill={color} />
    <text
      x="32"
      y="38"
      textAnchor="middle"
      fontSize="24"
      fill="#fff"
      fontWeight="bold"
    >
      ₹
    </text>
    <line
      x1="18"
      y1="46"
      x2="46"
      y2="18"
      stroke="#fff"
      strokeWidth="4"
    />
  </svg>
);

const SalaryTypeBadge = ({ type }) => {
  return type === "Deduction" ? <DeductionIcon /> : <EarningIcon />;
};

SalaryTypeBadge.propTypes = {
  type: PropTypes.oneOf(["Earning", "Deduction"]).isRequired,
};

EarningIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

DeductionIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default SalaryTypeBadge;
